import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const VideoService = {
    getdata:async() => {
        try{
            const response = await apiService.get("/videos");
            return response.data;
        }catch(error){
            console.log(error);
        }
    },
    getdetails:async(id) => {
        const response = await apiService.get(`/videos/${id}`);
        return response.data;
    },
    create: async(data) => {
        const response =await apiService.post("/videos",data);
        return response.data;
    },
    update:async(id,updateddata) => {
        const response = await apiService.put(`/videos/${id}`,updateddata);
        return response.data;
    },
    delete: async(id) => {
        const response = await apiService.delete(`/videos/${id}`);
        return response.data;
    }
}

export default VideoService;